import React, { useState, useEffect } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import MUIDataTable, { DefaultTableBody } from "mui-datatables";
import { Routes, Route, useNavigate } from "react-router-dom";
import useSave from "../../Hooks/useSave";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import useAlert from "../../Hooks/useAlerts";

export default function Users() {
  const navigate = useNavigate();
  const { fetchGraphql, DialogSave } = useSave();
  const [data, setData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [addAlert, Feedback] = useAlert();

  const addonOptions = {
    record: {
      userId: `new${data.length + 1}`,
      firstName: "",
      lastName: "",
      email: "",
      role: "",
    },
    focus: 1,
    edit: (tableMeta) => {},
    save: (tableMeta) => {
      const copyState = [...data];

      const user = copyState.find(
        (item) => item["userId"] === tableMeta.rowData[0]
      );

      const newUser = { ...user };

      delete newUser.userId;
      delete newUser.role;

      // console.log(user);
      if (user.userId.includes("new")) {
        // console.log("new");
        return fetchGraphql({
          query: `mutation createUser($user: userInput) {
            createUser(user: $user)
          }`,
          variables: { user: newUser },
        }).then((result) => {
          user.userId = result.data.createUser;

          setData(copyState);

          return Promise.resolve("done");
        });
      } else {
        // console.log("old");
        return fetchGraphql({
          query: `mutation UpdateUser($userId: ID, $user: userInput) {
            updateUser(userId: $userId, user: $user)
          }`,
          variables: {
            user: newUser,
            userId: user.userId,
          },
        }).then((result) => {
          return Promise.resolve("done");
        });
      }
    },
    send: (tableMeta) => {
      const copyState = [...data];

      const user = copyState.find(
        (item) => item["userId"] === tableMeta.rowData[0]
      );

      fetchGraphql({
        query: `mutation SendUpdateLoginCredentialsEmail($email: String!) {
          sendUpdateLoginCredentialsEmail(email: $email)
        }`,
        variables: { email: user.email },
      }).then((result) => {
        addAlert({
          severity: "success",
          message: "Message sent succesfuly",
        });
        // console.log(result);
      });
    },
    delete: (tableMeta) => {
      // console.log(tableMeta);
      fetchGraphql({
        query: `mutation DeleteUser($userId: ID) {
          deleteUser(userId: $userId)
        }`,
        variables: { userId: tableMeta.rowData[0] },
      });
    },
    rowsPerPage: 1000,
  };

  const [
    textField,
    selectField,
    newRecord,
    actions,
    options,
    checkboxField,
    multipleSelect,
  ] = useDatatableAddon(data, setData, "userId", addonOptions);

  const columns = [
    {
      name: "userId",
      options: {
        display: false,
      },
    },
    {
      name: "firstName",
      label: "First Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "125px",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "lastName",
      label: "Last Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "125px",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "250px",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "role",
      label: "Role",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "150px",
            id: "roleId",
            onChange: (newValue) => {
              // console.log("onChange", newValue);

              fetchGraphql({
                query: `query Query {
                  roles {
                    roleId
                    roleName
                  }
                }`,
              }).then((result) => setRoles(result.data.roles));
            },
            values:
              roles?.map((item) => ({
                roleId: item.roleId,
                title: item.roleName,
              })) || [],
          };

          return selectField(tableMeta, value, options, updateValue);
        },
      },
    },
    { ...actions },
  ];

  useEffect(() => {
    fetchGraphql({
      query: `query Query {
          users {
            userId
            firstName
            lastName
            phoneNumber
            email
            role
          }
          roles {
            roleId
            roleName
          }
        }
        `,
      variables: {},
    }).then((result) => {
      setData(result.data.users);
      setRoles(result.data.roles);
    });

    return () => {};
  }, []);

  const handleFilterSubmit = (applyFilters) => {
    let filterList = applyFilters();

    // console.log(filterList);
    // this.setState({ isLoading: true });

    // // fake async request
    // this.xhrRequest(`/myApiServer?filters=${filterList}`, filterList).then(
    //   (res) => {
    //     this.setState({ isLoading: false, data: res.data });
    //   }
    // );
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Feedback />

      <Button
        variant="contained"
        sx={{ margin: "0px 0px 20px auto" }}
        onClick={() =>
          newRecord({
            userId: `new${data.length + 1}`,
            firstName: "",
            lastName: "",
            email: "",
            role: "",
          })
        }
      >
        <DialogSave />
        <AddIcon />
        New User
      </Button>

      <MUIDataTable
        title={"Users"}
        data={data}
        columns={columns}
        options={options}
      /> 
    </Box>
  );
}
